<template>
  <div class="pedido-listado">
    <section class="pedido-steps">
    <div class="container">
      
      <div class="row">
        <div class="col-12">
          <div class="return d-block d-sm-none">
            <router-link to="/pricing-home">
              <img :src="require('../../../assets/img/backspace.svg')" class="mb-5">
            </router-link>
          </div>
          <div class="section-title">
            <h5 class="pull-left" title="Ajuda sobre o histórico de preços">
              {{ $t('pricing.history.title') }}
            </h5>
            <router-link to="/pricing-home">
              <img class="d-none d-sm-block" :src="require('../../../assets/img/backspace.svg')">
            </router-link>
          </div>
        </div>
      </div>

      <form class="form-filter">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>{{ $t('pricing.history.client') }}</label>
              <VueMultiselect
                v-model="filters.id_distribuidor"
                :options="clientesOptions"
                :searchable="true"
                :close-on-select="true"
                :show-labels="false"
                :custom-label="(option) => `${option.value} - ${option.text}`"
                placeholder="Seleccione un Cliente"
                @input="enableFilterButtons"
              />
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label>{{ $t('pricing.history.plant_name') }}</label>
              <VueMultiselect
                v-model="filters.planta"
                :options="plantasOptions"
                :searchable="true"
                :close-on-select="true"
                :show-labels="false"
                :custom-label="(option) => `${option.value} - ${option.text}`"
                placeholder="Seleccione una Planta"
                @input="enableFilterButtons"
              />
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label>{{ $t('pricing.history.sku') }}</label>
              <VueMultiselect
                v-model="filters.sku_id"
                :options="skusOptions"
                :searchable="true"
                :close-on-select="true"
                :show-labels="false"
                :custom-label="(option) => `${option.value} - ${option.text}`"
                placeholder="Seleccione un SKU"
                @input="enableFilterButtons"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>USD / lb</label>
              <input type="number" v-model="filters.precio_usuario" @input="enableFilterButtons" class="form-control" placeholder="" />
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label>USD / caja</label>
              <input type="number" v-model="filters.precio_usd_caja" @input="enableFilterButtons" class="form-control" placeholder="" />
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label>USD / kg</label>
              <input type="number" v-model="filters.precio_usd_kg" @input="enableFilterButtons" class="form-control" placeholder="" />
            </div>
          </div>
        </div>

        <div class="row align-items-end">
          <div class="col-md-4">
            <div class="form-group">
              <label>{{ $t('pricing.history.start_date') }}</label>
              <Datepicker
                  v-model="filters.start_date"
                  name="fecha-finish"
                  :enableTimePicker="false"
                  textInput
                  autoApply
                  format="dd/MM/yyyy"
                  inputClassName="dp-input-custom"
                  utc="preserve"
                  required
                  @change="enableFilterButtons"
              />
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label>{{ $t('pricing.history.end_date') }}</label>
              <Datepicker
                  v-model="filters.end_date"
                  name="fecha-finish"
                  :enableTimePicker="false"
                  textInput
                  autoApply
                  format="dd/MM/yyyy"
                  inputClassName="dp-input-custom"
                  utc="preserve"
                  required
                  @change="enableFilterButtons"
              />
            </div>
          </div>

          <div class="col-md-4 next-btn">
            <a @click="clearFilters" href="javascript:void(0)" class="btn-white">Limpiar</a>
            <a href="javascript:void(0)" @click="applyFilters()" class="btn-green">Buscar</a>
          </div>

        </div>
      </form>

      <div class="row">
        <div class="col-md-12">
          <div class="confirmado mt-2">
            
            <table class="bg-white d-none d-sm-table" id="pedidosTable">
              <thead>
                <tr style="background-color: #fffadc;">
                  <th class="text-center">{{ $t('pricing.history.id_distribuidor') }}</th>
                  <th class="text-center">{{ $t('pricing.history.client') }}</th>
                  <th class="text-center">{{ $t('pricing.history.plant') }}</th>
                  <th class="text-center">{{ $t('pricing.history.plant_name') }}</th>
                  <th class="text-center">{{ $t('pricing.history.sku_id') }}</th>
                  <th class="text-center">{{ $t('pricing.history.sku') }}</th>
                  <th class="text-center">{{ $t('pricing.history.start_date') }}</th>
                  <th class="text-center">{{ $t('pricing.history.end_date') }}</th>
                  <th class="text-center">{{ $t('pricing.history.precio_usd_kg') }}</th>
                  <th class="text-center">{{ $t('pricing.history.precio_usuario') }}</th>
                  <th class="text-center">{{ $t('pricing.history.precio_usd_caja') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr class="b-top" v-for="(row, index) in paginatedHistory" :key="index + '-' + currentPage">
                  <td class="text-center">{{ row.id_distribuidor }}</td>
                  <td class="text-center">{{ row.name_distribuidor }}</td>
                  <td class="text-center">{{ row.planta }}</td>
                  <td class="text-center">{{ row.plant_name }}</td>
                  <td class="text-center">{{ row.sku_id }}</td>
                  <td class="text-center">{{ row.sku_name }}</td>
                  <td class="text-center">{{ row.start_date }}</td>
                  <td class="text-center">{{ row.end_date }}</td>
                  <td class="text-center">{{ row.precio_usd_kg }}</td>
                  <td class="text-center">{{ formatPrecioUsuario(row.precio_usuario) }}</td>
                  <td class="text-center">{{ row.precio_usd_caja }}</td>
                </tr>
              </tbody>
            </table>

            <div class="d-block d-sm-none mobile-card-wrapper"
                v-for="(row, index) in paginatedHistory" :key="index + '-' + currentPage">
              <table class="bg-white pedidosTableMobile">
                <tr><th>Id Cliente</th><td>{{ row.id_distribuidor }}</td></tr>
                <tr><th>Cliente</th><td>{{ row.name_distribuidor }}</td></tr>
                <tr><th>Id Planta</th><td>{{ row.planta }}</td></tr>
                <tr><th>Planta</th><td>{{ row.plant_name }}</td></tr>
                <tr><th>Id SKU</th><td>{{ row.sku_id }}</td></tr>
                <tr><th>SKU</th><td>{{ row.sku_name }}</td></tr>
                <tr><th>Fecha Desde</th><td>{{ row.start_date }}</td></tr>
                <tr><th>Fecha Hasta</th><td>{{ row.end_date }}</td></tr>
                <tr><th>Precio USD/kg</th><td>{{ row.precio_usd_kg }}</td></tr>
                <tr><th>Precio USD/lb</th><td>{{ formatPrecioUsuario(row.precio_usuario) }}</td></tr>
                <tr><th>Precio USD/caja</th><td>{{ row.precio_usd_caja }}</td></tr>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-12 d-flex align-items-center flex-wrap">
          <button class="btn-green" @click="downloadHistory" style="cursor: pointer;">
            Descargar
          </button>
          <button v-if="isPricingCoord" class="btn-green" @click="triggerUpload" style="cursor: pointer;">
            {{ $t('pricing.history.upload_price_history') }}
          </button>

          <nav>
            <ul class="pagination mb-0">
              <li class="page-item" :class="{ disabled: currentPage === 1 }">
                <a class="page-link" href="#" @click.prevent="onPageChange(currentPage - 1)">‹</a>
              </li>
              <li class="page-item" v-for="page in visiblePageNumbers" :key="page" :class="{ active: currentPage === page }">
                <a class="page-link" href="#" @click.prevent="onPageChange(page)">{{ page }}</a>
              </li>
              <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                <a class="page-link" href="#" @click.prevent="onPageChange(currentPage + 1)">›</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      <input ref="uploadInput" type="file" accept=".xlsx,.xls" style="display: none;" @change="handleFileUpload" />
    </div>
  </section>
  <vue-basic-alert :duration="300" :closeIn="1000000" ref="alert"/>
</div>
</template>

<script setup>
import { ref, reactive, onMounted, computed } from 'vue'
import axios from 'axios'
import { useI18n } from 'vue-i18n'
import { formatPrecioUsuario } from '@/assets/js/priceFormat'
const { t } = useI18n()

const filters = reactive({
  id_distribuidor: '',
  planta: '',
  sku_id: '',
  precio_usuario: '',
  precio_usd_caja: '',
  precio_usd_kg: '',
  start_date: '',
  end_date: ''
})

const clientesOptions = ref([])
const plantasOptions = ref([])
const skusOptions = ref([])
const historyData = ref([])

const currentPage = ref(1)
const rowsPerPage = 10
const canFilter = ref(false)

const uploadInput = ref(null)
const alert = ref(null)
const isPricingCoord = ref(false)

const paginatedHistory = computed(() => {
  const start = (currentPage.value - 1) * rowsPerPage
  const end = start + rowsPerPage
  return historyData.value.slice(start, end)
})

const totalPages = computed(() => {
  return Math.ceil(historyData.value.length / rowsPerPage)
})

const visiblePageNumbers = computed(() => {
  const maxVisible = 10;
  const pages = [];

  let start = Math.max(currentPage.value - Math.floor(maxVisible / 2), 1);
  let end = start + maxVisible - 1;

  if (end > totalPages.value) {
    end = totalPages.value;
    start = Math.max(end - maxVisible + 1, 1);
  }

  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  return pages;
})

const formatDateToYMD = (date) => {
  if (!date) return ''
  // The datepicker (utc="preserve") and earlier calls give the civil date as a
  // "YYYY-MM-DD..." string: keep it as is, so a negative UTC offset cannot move it.
  if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}/.test(date)) return date.slice(0, 10)
  const d = new Date(date)
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

const showAlert = (type, title, message) => 
{
  if (alert.value) {
    alert.value.showAlert(
      type,      
      message,    
      title,      
      {
        iconSize: 35,
        iconType: 'solid',
        position: 'top right'
      }
    )
  }
}

// Same filters for the list and the download, built without touching the datepickers.
const requestFilters = () => ({
  ...filters,
  start_date: formatDateToYMD(filters.start_date),
  end_date: formatDateToYMD(filters.end_date)
})

const handleRequestError = (error) => {
  const response = error.response
  const status = response && response.status
  if (status === 403) {
    showAlert('error', t('errors.title'), t('errors.forbidden'))
  } else if (status === 422 && response.data && typeof response.data.message === 'string') {
    // Expected validation errors, e.g. an invalid Excel header, keep the API message.
    showAlert('error', t('errors.title'), response.data.message)
  } else {
    showAlert('error', t('errors.title'), t('errors.server_error'))
  }
}

const loadIsPricingCoord = () => {
  try {
    const raw = sessionStorage.getItem('mccain_service_user_profile')
    if (raw) {
      const parsed = JSON.parse(raw)
      isPricingCoord.value = parsed?.Princing_profile === 'pricing_coord' || false
    }
  } catch (e) {
    isPricingCoord.value = false
  }
}

const enableFilterButtons = () => {
  canFilter.value = true
}

const clearFilters = () => {
  Object.keys(filters).forEach(k => filters[k] = '')
  canFilter.value = false
  currentPage.value = 1
  fetchHistory()
}

const fetchFiltersData = () => {
  axios.get('/pricing/getFilterData')
    .then(res => {
      // No response: a 401 the interceptor is already turning into a login redirect.
      if (!res) return
      clientesOptions.value = res.data.items.clientes.map(c => ({ value: c.sold_to, text: c.sold_to_name }))
      plantasOptions.value = res.data.items.plantas.map(p => ({ value: p.DC, text: p.plant_name }))
      skusOptions.value = res.data.items.skus.map(s => ({ value: s.sku_id, text: s.sku_name }))
    })
    .catch(handleRequestError)
}

const fetchHistory = () => {
  const payload = { filtros: requestFilters() }

  axios.post('/pricing/getHistoryByFilter', payload)
    .then(res => {
      // No response: a 401 the interceptor is already turning into a login redirect.
      if (!res) return
      historyData.value = res.data.items || []
      currentPage.value = 1 
    })
    .catch(handleRequestError)
}

const applyFilters = () => {
  currentPage.value = 1
  fetchHistory()
}

const onPageChange = (page) => {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page
  }
}

const downloadHistory = () => {
  try {
    const title = t('pricing.history.title');
    const header = [
      t('pricing.history.id_distribuidor'),
      t('pricing.history.client'),
      t('pricing.history.plant'),
      t('pricing.history.plant_name'),
      t('pricing.history.sku_id'),
      t('pricing.history.sku'),
      t('pricing.history.start_date'),
      t('pricing.history.end_date'),
      t('pricing.history.precio_usd_kg'),
      t('pricing.history.precio_usuario'),
      t('pricing.history.precio_usd_caja')
    ];

    if (!filters) {
      console.error("Filtros não definidos.");
      return;
    }

    axios.post('/pricing/downloadHistory', {
      filtros: requestFilters(),
      history_title: title,
      header: header
    }, {
      responseType: 'blob'
    }).then(response => {
      // No response: a 401 the interceptor is already turning into a login redirect.
      if (!response) return
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'historico.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove(); 
      window.URL.revokeObjectURL(url); 
    }).catch(handleRequestError);
  } catch (e) {
    console.error("Erro inesperado:", e);
  }
}

const triggerUpload = () => {
  uploadInput.value.click()
}

const handleFileUpload = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const formData = new FormData();
  formData.append('file', file);

  axios.post('/pricing/uploadHistory', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
  .then(response => {
    // No response: a 401 the interceptor is already turning into a login redirect.
    if (!response) return
    showAlert('success', 'Éxito!', response.data.message);
    uploadInput.value.value = '';
    fetchHistory();
  })
  .catch(handleRequestError)
}

onMounted(() => {
  loadIsPricingCoord()
  fetchFiltersData()
  fetchHistory()
})
</script>

<style scoped>
.sub-header {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
